import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { Link } from 'react-scroll';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import CaseStudyHero from '../../../components/CaseStudyHero';
import UserTestimonyCardNoLogo from '../../../components/cards/UserTestimonyCardNoLogo';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import '../../../scss/pages/_customer-story-page.scss';
import { PATHS } from '../../../utils/urls';

const Resources = (props) => {
	const location = props.location;

	return (
		<Layout bodyClass="customer-story-page even-story-page" ontouchstart>
			<SEO title="Case Study: Even Financial | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta
					name="description"
					content="Even Financial needed to scale the impact of their small HR team. ChartHop helped them empower business leaders with data and make data-informed people decisions."
				/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Case Study: Even Financial | ChartHop | The Org Management Platform" />
				<meta property="og:description" content="Even Financial needed to scale the impact of their small HR team. ChartHop helped them empower business leaders with data and make data-informed people decisions." />
				<meta property="og:image" content={`https://www.charthop.com/home/charthop-facebook.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Case Study: Even Financial | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="Even Financial needed to scale the impact of their small HR team. ChartHop helped them empower business leaders with data and make data-informed people decisions. " />
				<meta name="twitter:image" content={`https://www.charthop.com/home/charthop-twitter.jpg`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

            <CaseStudyHero
                name="Even Financial"
                title="Empowering business leaders and making data-informed decisions"
                logo="/customers/even/even-logo.svg"
                titlePosition="top"
				background="/customers/customer-stories/background-hero.png"
				pdfUrl="/customers/even-financial-case-study.pdf"
				caseStudySource="customers-even-PDF-case-study-header"
            />

			<section className="sectionArrow">
			<Link to="testimonySection" smooth={true} offset={-70} duration={500}><div class="arrow bounce"></div></Link>
			</section>

			{/* USER TESTIMONY SECTION*/}
			<section className="testimonySection text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={HtmlParser('<p>"I value ChartHop so much as a People leader. The system is comprehensive, the UI is intuitive and the workflow is clean and logical.</p><p>I&#39;m very excited to finally have a system in place that supports data-driven headcount planning decisions.</p><p>Unlike many other HR systems, there is no selling required to yield internal adoption. Once my business owners were provided access and given a tour of the dashboards we built for them, they were hooked."</p>')}
						name="Kyle Roberts"
						position="Chief People Officer @ Even"
						image="/customers/even/kyle-roberts_even-th.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>			

			{/*Before ChartHop Section */}
			<section className="before-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div  className="row align-items-center pt-3 pt-mt-4 pt-lg-5">
						{/*Before Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Growing quickly and feeling the growing pains</h2>
								<p>As a fast growing tech company, Even Financial’s environment was dynamic in every way, including in its organization structure.</p>
								<p>
									Open positions often shifted in scope and priority, resulting in wasted hours of recruiting work, pipeline and budgeting challenges.
								</p>
								<p>
									Org charts were static, manually updated powerpoint slides that are laborious to keep up to date. Department heads had no visibility into dynamic implications of their teams as they grew.
								</p>
								<p>
									 And providing leaders with historical compensation adjustments as a way to support recognition and reward decisions was a manual, cumbersome exercise for the small HR team of 2.
								</p>
								<p>
								 	<b>These inefficiencies were easily valued at over $500K per year across the organization - or funds equal to 3 additional heads! </b> 
								</p>
								<p>
									They wanted to provide leaders with the information they needed to run their business units, manage and grow their teams and make the best decisions for the company. 
								</p>
							</div>
						</div>

						{/*About Mongo can COl */}
						<div className="containerAbout col-md-5 col-lg-6" >	          
							<div className="flex-centeredColumn contentBlock background-about">
								<h4 className="h4-big"><strong>About</strong></h4>
								<img src={'/customers/even/even-logo-white.svg'} alt="Even Financial" style={{margin: `auto`, maxWidth: 200}}/>
								<h4 className="h4-big"><strong>-</strong></h4>
								<h4><strong>Founded:</strong> 2015</h4>
								<h4><strong>Industry:</strong> Technology</h4>
								<h4><strong>Type:</strong> Private</h4>
								<h4><strong>Number of Employees:</strong> 80</h4>
							</div><br/><br/>

							<h4 className="text-center seeking-title"><strong>Even Financial was seeking people ops efficiencies in:</strong></h4>
							<br/>
							<div className="flex-centeredColumn contentBlock">
								<div className="flex-platform svg-info-beforeChartHop">
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/time2.svg '} alt="Visualize" />
										<p>Time</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/money.svg'} alt="Put a face to the name" />
										<p>Money</p>
									</div>
									<div className="svg-info-card-3col2 ">
										<img src={'/product/org-chart/productivity2.svg'} alt="Time Saving" />
										<p>Productivity</p>
									</div>        
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION*/}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={<p>
							 "ChartHop gives me a time series view of our workforce and easily allows leaders to see how company resourcing needs change over time. This allows me to forecast future headcount and spend changes." 
							</p>}
						name="Weifang Zhu"
						position="SVP Growth & Operations @ Even"
						image="/customers/even/weifang-zhu_even-th.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>

			{/* With ChartHop Section */}
			<section className="with-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5">
						{/* With Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Saving resources by making data-informed decisions</h2>
								<p>
								ChartHop, with its sophisticated integration capabilities, enabled Even Financial to <b>centralize</b> and <b>sanitize</b> all workforce data, including their historical data. 
								</p><p>
								Because of ChartHop’s robust customization capabilities, Even’s People team was then able to build custom dashboards for each business leader, arming each with reliable data and getting back those 10 hours they were spending fielding individual questions. 
								</p><p>
								<b>Most valuable to Even’s Chief People Officer and leadership team, is ChartHop’s scenario building functionality.</b> With recruiting efforts driven by approved, detailed scenarios, open positions are appropriately scoped, prioritized and budgeted, recruiting efforts are effectively managed and Even’s overall time to fill is significantly reduced. 
								</p><p>
								This functionality allows for thorough examination of how various workforce changes across the organization would impact the business from a cost, skillset, resource allocation and collaboration perspective. 
								</p>
							</div>
						</div><br/>

						{/*Now Even Financial can COl */}
						<div className="containerNow col-md-5 col-lg-6" >		          
							<div className="flex-centeredColumn contentBlock background-withCharthop">
							<h4 className="text-center"><strong>Now Even Financial can:</strong></h4>
								<div className="flex-platform svg-info2-withCharthop">
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/data-centralization.svg'} alt="Visualize" />
										<p>Empower data-informed decisions</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/compensation.svg'} alt="Put a face to the name" />
										<p>Access and share accurate reports</p>
									</div>
									<div className="svg-info-card-3col2 people-width">
										<img src={'/customers/customer-stories/prioritize.svg'} alt="Time Saving" />
										<p>Prioritize and budget workorce changes</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/light.svg'} alt="Transparency" />
										<p>Iterate on people strategy using data</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/*Bullets Section */}
					<div className="sectionSpacing flex-centeredColumn with-charthop-section">
						<div className="contentBlock">
							<h4 className="text-center">Even’s Chief People Officer and leadership team leverage <strong className="p-lightblue">ChartHop Scenarios</strong> to:</h4>
							<div className="flex-centeredColumn contentBlock">
								<div className="pgc1">
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p className="text-left">Model all workforce changes</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>Accurately budget headcount expenses</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>Prioritize and align on open roles</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>Approve annual and ad-hoc requests</p>
										</div>
									</div>
								</div>
							</div>
							<p className="text-center pb-3">With ChartHop, Even could have <strong className="p-lightblue">saved at least $400,000</strong> when they were growing the team in 2019.</p>
						</div>
						<div className="">
							<center><a className="button button-withCharthop" rel="noopener noreferrer" target="_blank" href={PATHS.PLANNING}>PLAN WITH SCENARIOS</a></center>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION */}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={<p>
							 "ChartHop is a comprehensive workforce management system that empowers business leaders to collaborate around headcount planning efforts, arming them with the data necessary to examine how various changes impact the business." 
							</p>}
						name="Kyle Roberts"
						position="Chief People Officer @ Even"
						image="/customers/even/kyle-roberts_even-th.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>		

			{/* TRUSTED */}
			<section className="customer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>			

			{/* LONG FORM */}
			{/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"customers-even-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"ChartHop is a great, intuitive and helpful resource. </p><p class=" mb-3 contact-testimonial">I always know where to look for quick, up-to-date org charts, and the self-serve tools make complicated benefits (like equity vesting and valuation) easy!.</p><div class="authorTag"><img src="/customers/even/ChrisSchellens_Even.jpeg" class="testimonialAuthor" alt="Chris Schellens" /><div><p class="contactAuthor"><strong>Chris Schellens</strong> <br>Director, Strategy @ Even Financial</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Resources;